
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_1f803_9",
  "wizard": "awsui_wizard_1xupv_1f803_41",
  "refresh": "awsui_refresh_1xupv_1f803_41",
  "small-container": "awsui_small-container_1xupv_1f803_48",
  "navigation": "awsui_navigation_1xupv_1f803_62",
  "number": "awsui_number_1xupv_1f803_95",
  "circle": "awsui_circle_1xupv_1f803_111",
  "title": "awsui_title_1xupv_1f803_122",
  "active": "awsui_active_1xupv_1f803_153",
  "disabled": "awsui_disabled_1xupv_1f803_164",
  "enabled": "awsui_enabled_1xupv_1f803_174",
  "form": "awsui_form_1xupv_1f803_218",
  "form-header": "awsui_form-header_1xupv_1f803_223",
  "form-header-content": "awsui_form-header-content_1xupv_1f803_238",
  "form-component": "awsui_form-component_1xupv_1f803_242",
  "hidden": "awsui_hidden_1xupv_1f803_258",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_1f803_262",
  "collapsed-steps-navigation": "awsui_collapsed-steps-navigation_1xupv_1f803_268",
  "form-header-component-wrapper": "awsui_form-header-component-wrapper_1xupv_1f803_277",
  "form-header-component": "awsui_form-header-component_1xupv_1f803_277",
  "navigation-link": "awsui_navigation-link_1xupv_1f803_293",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_1f803_294",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_1f803_295",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_1f803_299",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_1f803_304",
  "cancel-button": "awsui_cancel-button_1xupv_1f803_308",
  "previous-button": "awsui_previous-button_1xupv_1f803_309",
  "primary-button": "awsui_primary-button_1xupv_1f803_310",
  "skip-to-button": "awsui_skip-to-button_1xupv_1f803_311",
  "action-buttons": "awsui_action-buttons_1xupv_1f803_315"
};
  